export default __webpack_public_path__ + "static/media/deletes.1bf8d81c.svg";